<template>
    <div class="layer"
         v-loading="loading">
        <h2>검색 결과 : 총 {{totalCount}}건</h2>
        <el-table :data="list"
                  border
                  stripe
                  style="width: 100%">
            <el-table-column prop="artId"
                             label="작품ID"
                             fixed
                             width="160">
            </el-table-column>
            <el-table-column label="앞면"
                             fixed
                             width="160">
                <template slot-scope="scope">
                    <img :src="getFrontResultCoverUrl(scope.row.resources)" :alt="scope.row.artId" width="120px">
                </template>
            </el-table-column>
            <el-table-column label="뒷면"
                             fixed
                             width="160">
                <template slot-scope="scope">
                    <img :src="getBackResultCoverUrl(scope.row.resources)" :alt="scope.row.artId" width="120px">
                </template>
            </el-table-column>
            <el-table-column prop="productType"
                             label="상품종류"
                             width="120">
            </el-table-column>
            <el-table-column prop="userId"
                             label="제작자ID"
                             width="160">
            </el-table-column>
            <el-table-column label="제작자 이름"
                             width="200">
                <template slot-scope="scope">
                    {{scope.row.user && scope.row.user.name}}
                </template>
            </el-table-column>
            <el-table-column label="파트너 정보(key)"
                             width="160">
                <template slot-scope="scope">
                    {{scope.row.partner && scope.row.partner.name}}<br/>
                    ({{scope.row.partner && scope.row.partner.partnerKey}})
                </template>
            </el-table-column>
            <el-table-column prop="pickCount"
                             label="담은 회수"
                             width="120">
            </el-table-column>
            <el-table-column label="생성일"
                             width="200">
                <template slot-scope="scope">{{scope.row.createdAt | dateTime}}</template>
            </el-table-column>
            <el-table-column label="마지막 수정일"
                             width="200">
                <template slot-scope="scope">{{scope.row.updatedAt | dateTime}}</template>
            </el-table-column>
            <el-table-column label="태그"
                             width="500">
                <template slot-scope="scope">
                    <el-tag type="warning"
                            effect="dark"
                            v-for="item in scope.row.tags" :key="item.tag">#{{item.tag}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="상태"
                             fixed="right"
                             width="80">
                <template slot-scope="scope">
                    <el-tag type="success" effect="dark" v-if="scope.row.isValid">정상</el-tag>
                    <el-tag type="danger" effect="dark" v-else>정지</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="공개여부"
                             fixed="right"
                             width="80">
                <template slot-scope="scope">
                    <el-tag type="success" effect="dark" v-if="scope.row.isPublic">공개</el-tag>
                    <el-tag type="danger" effect="dark" v-else>비공개</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="관리"
                             fixed="right"
                             width="160">
                <template slot-scope="scope">
                    <el-button type="warning" size="small" @click.prevent="showDetail(scope.row)">상세보기</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :page-size="pageSize"
                       :current-page="page"
                       :pager-count="11"
                       :total="totalCount"
                       layout="prev, pager, next"
                       @current-change="getArts">
        </el-pagination>

        <el-dialog title="작품 상세 정보"
                   :visible.sync="isShowDetailModal"
                   width="600px">
            <p class="tip">이미지를 클릭하면 다운로드됩니다.</p>
            <div v-for="page in resources" :key="page.name">
                <h1 class="page-name">{{page.name}}</h1>
                <div>
                    <h2>결과 / 결과 마스킹 제거 버전</h2>
                    <a :href="page.resultCover" target="_blank" download>
                        <img :src="page.resultCover" :alt="page.name" width="120px">
                    </a>
                    <a :href="page.result" target="_blank" download>
                        <img :src="page.result" :alt="page.name" width="120px">
                    </a>
                </div>
                <div v-if="page.images.length > 0">
                    <h2>사용된 이미지</h2>
                    <a v-for="path in page.images"
                       :key="path"
                       :href="path"
                       target="_blank"
                       download>
                        <img :src="path" :alt="page.name" width="120px">
                    </a>
                </div>
                <div v-if="page.logos.length > 0">
                    <h2>사용된 로고</h2>
                    <a v-for="path in page.logos"
                       :key="path"
                       :href="path"
                       target="_blank"
                       download>
                        <img :src="path" :alt="page.name" width="120px">
                    </a>
                </div>
                <div>
                    <h2>색상 정보</h2>
                    {{page.metaData}}
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="isShowDetailModal = false">닫기</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import imageController from '@/components/mixins/imageController';
    import errorController from '@/components/mixins/errorController';
    import {ART_GET_LIST, ART_RESET_LIST} from '@/store/modules/art';
    import {IMAGE, LOGO, RESULT, RESULT_COVER} from '@/const/resourceTypes';
    import {BACK, FRONT} from '@/const/resourcePageNames';

    export default {
        name: 'ArtList',
        mixins: [imageController, errorController],
        data() {
            return {
                loading: false,

                isShowDetailModal: false,
                resources: [],
            };
        },
        watch: {
            filters: {
                deep: true,
                handler() {
                    this.getArts();
                },
            },
        },
        computed: {
            list() {
                return this.loading ? [] : this.$store.state.art.list;
            },
            page() {
                return this.$store.state.art.page;
            },
            pageSize() {
                return this.$store.state.art.pageSize;
            },
            totalCount() {
                return this.$store.state.art.totalCount;
            },
            filters() {
                return this.$store.state.art.filters;
            },
        },
        methods: {
            async getArts(page = 1) {
                this.loading = true;
                try {
                    await this.$store.dispatch(ART_GET_LIST, page);
                } catch (err) {
                    await this.$store.dispatch(ART_RESET_LIST);
                    this.displayApiError(err);
                } finally {
                    this.loading = false;
                }
            },
            getFrontResultCoverUrl(resources) {
                return this.findResourcePublicPath(resources, FRONT, RESULT_COVER)[0];
            },
            getBackResultCoverUrl(resources) {
                return this.findResourcePublicPath(resources, BACK, RESULT_COVER)[0];
            },
            showDetail(art) {
                this.isShowDetailModal = true;
                this.resources = [{
                    name: FRONT,
                    resultCover: this.findResourcePublicPath(art.resources, FRONT, RESULT_COVER)[0],
                    result: this.findResourcePublicPath(art.resources, FRONT, RESULT)[0],
                    images: this.findResourcePublicPath(art.resources, FRONT, IMAGE),
                    logos: this.findResourcePublicPath(art.resources, FRONT, LOGO),
                    metaData: art.metaData.find(item => item.name === FRONT),
                }, {
                    name: BACK,
                    resultCover: this.findResourcePublicPath(art.resources, BACK, RESULT_COVER)[0],
                    result: this.findResourcePublicPath(art.resources, BACK, RESULT)[0],
                    images: this.findResourcePublicPath(art.resources, BACK, IMAGE),
                    logos: this.findResourcePublicPath(art.resources, BACK, LOGO),
                    metaData: art.metaData.find(item => item.name === BACK),
                }];
            },
            findResourcePublicPath(resources, pageName, resourceType) {
                return resources
                    ?.filter(resource => resource.pageName === pageName && resource.resourceType === resourceType)
                    .map(resource => this.getImageFullPath(resource.publicPath));
            },
        },
        async created() {
            await this.getArts();
        },
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 16px;
        margin-bottom: 5px;
        color: #545c64;
    }

    .tip {
        margin-bottom: 20px;
        color: #545c64;
    }

    .page-name {
        margin-bottom: 10px;
        color: #545c64;
        font-size: 20px;
    }
</style>